import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {api} from "../api/api";
import {useLanguageStore} from "../store/languageStore";
import {Link} from 'react-router-dom';


export default function CeramicTileInstallation() {

    const [solution, setSolution] = useState(null);
    const {language} = useLanguageStore();
    const isArabic = language === 'ar';


    const {id} = useParams();

    useEffect(() => {
        api.get(`solutions/${id}/`).then((res) => {
            console.log(res.data)
            setSolution(res.data)
        })
    }, [])

    return (
        <div className={`max-w-6xl mx-auto p-6 ${isArabic ? 'rtl text-right' : 'ltr text-left'}`}>
            <div className="flex justify-between items-center mb-6">


            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div>
                    <div className="bg-gray-100 rounded-lg overflow-hidden mb-6">
                        <img loading="lazy"
                            src={solution?.image}
                            alt="Ceramic tile installation"
                            className="w-full h-auto"
                        />
                    </div>
                </div>

                <div>
                    <h1 className={`text-3xl font-bold ${isArabic? ' text-right' : 'ltr text-left'}`}>{
                        isArabic ? solution?.title_ar : solution?.title_en
                    }</h1>
                    <p className={`text-gray-700 my-4 ${isArabic? ' text-right' : 'ltr text-left'}`}>{isArabic ? solution?.head_description_ar : solution?.head_description_en}</p>

                    <h2 className="text-2xl font-bold mt-8 mb-4">{isArabic ? "المواد المستخدمة" : 'Materials Used'}</h2>

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                        {solution?.related_products?.map((product) => (
                            <Link to={`/product/${product.id}`}>
                                <div className="bg-white p-4 flex flex-col h-full shadow-md rounded-lg ">
                                    <div className="flex justify-center mb-4">
                                        <img loading="lazy"
                                             src={product.image}
                                             alt={product.name}
                                             className="w-full  object-cover rounded-md"
                                        />
                                    </div>
                                    <h3 className="font-bold text-lg mb-2 line-clamp-1">{isArabic ? product.name_ar : product.name_en}</h3>
                                    <p className="text-gray-600 text-sm line-clamp-3">{isArabic ? product.description_ar : product.description_en}</p>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>


            <div
                className="custom-html"
                dir={isArabic? 'rtl' : 'ltr'}
                dangerouslySetInnerHTML={{
                    __html: isArabic ? solution?.description_ar : solution?.description_en,
                }}
            />


        </div>
    );
}